import { Component, AfterViewInit, ElementRef, ViewChild, inject, OnInit, AfterContentChecked } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import * as bootstrap from 'bootstrap';
import { CmsDataService } from '../../services/cms.service';
import { CmsProjectGroupByTag } from '../../models/cms-data.model';

@Component({
    selector: 'helper',
    standalone: true,
    template: `
    <div class="dropdown" *transloco="let t;">
        <button id="helpButton" type="button" [title]="t('header.help')"
            class="btn btn-link text-decoration-none d-flex align-items-center justify-content-center px-0" 
            aria-haspopup="menu" data-bs-toggle="dropdown" aria-expanded="false"
            [attr.aria-label]="t('header.help')">
            <i class="fa-regular fa-circle-question fs-5" aria-hidden="true"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="helpButton">
            <li><h6 class="dropdown-header">{{ t('header.help') }}</h6></li>
            <li>
                <a class="dropdown-item d-flex gap-2" href="https://smds.dk/web-patient-borger/"
                    target="_blank" rel="noopener noreferrer">
                    <span class="me-auto">{{ t('header.schemaguide') }}</span>
                    <span class="visually-hidden">({{ t('header.opensinanewtab') }})</span>
                    <i class="fa-solid fa-arrow-up-right-from-square align-content-center" aria-hidden="true"></i>
                </a>
            </li>
            <li>
                <a class="dropdown-item d-flex gap-2"
                    href="https://smds.dk/wp-content/uploads/2021/05/Vejledning-Kundens-brug-af-Web-Patient-02.02.2017.pdf"
                    target="_blank" rel="noopener noreferrer">
                    <span class="me-auto">{{ t('header.attestsguide') }}</span>
                    <span class="visually-hidden">({{ t('header.opensinanewtab') }})</span>
                    <i class="fa-solid fa-arrow-up-right-from-square align-content-center" aria-hidden="true"></i>
                </a>
            </li>
        </ul>
    </div>
  `,
    imports: [TranslocoDirective]
})
export class HelperComponent { }